export {};
//# sourceMappingURL=overwrite-accessors-function.js.map